import { Home } from "pages/index";

export const routes = [
    {
        path: "/",
        name: "Home",
        component: '<Home/>',
        hidden: false
    }
];